// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".newsDetails-head-autocomplete /deep/ .el-scrollbar__view li {\n  position: relative;\n  padding: 0 20px 0 20px;\n}\n.newsDetails-head-autocomplete /deep/ .el-scrollbar__view li .name {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.newsDetails-head-autocomplete /deep/ .el-scrollbar__view li .addr {\n    position: absolute;\n    top: 0;\n    right: 20px;\n    font-size: 12px;\n    color: #f59a23;\n}\n", ""]);
// Exports
module.exports = exports;
